import CCPortfolioTable from './CCPortfolioTable'

export default CCPortfolioTable
